import {useEffect, useState} from "react";
import {MAX_PATH, REST_URL} from "../../component/const/Const";
import {useNavigate} from "react-router-dom";
import {Survey} from "./Survey/Survey";
import {Short} from "./Short/Short";
import {Prompt} from "./Prompt/Prompt";
import {Trans} from "./Trans/Trans";
import {Context} from "./component/context";
import axios from "axios";
import {options} from "./component/const";

export const CreateTemplate = () => {
    const navigate = useNavigate();
    const [type, setType] = useState([])
    const [grading, setGrading] = useState([])
    const [template, setTemplate] = useState({
        name: "",
        type: '',
        grading: '',
        keywords: [''],
    })

    const onChangeKeyword = (value, index) => {
        const keywords = template.keywords
        keywords[index] = value
        setTemplate(prev => ({
            ...prev,
            keywords: keywords
        }))
    }

    const addKeyword = () => {
        setTemplate(prev => ({
            ...prev,
            keywords: [...prev.keywords, '']
        }))
    }

    const [problems, setProblems] = useState([])
    const [isTS, setIsTS] = useState(null)
    const [meta, setMeta] = useState({})
    useEffect(() => {
        fetch(`${REST_URL}rpc/get_enum_values?p_enum_name=test_type`)
            .then(res => res.json())
            .then(data => setType(data))
        fetch(REST_URL + 'rpc/get_enum_values?p_enum_name=grading')
            .then(res => res.json())
            .then(data => setGrading(data))
    }, []);

    const show = (id) => {
        const toHide = document.getElementsByClassName('templates')
        Array.from(toHide).forEach((element) => {
            if (!element.classList.contains('hidden')) {
                element.classList.add('hidden');
            }
        })
        document.getElementById(id).classList.remove('hidden')
    }

    const [path, setPath] = useState('')
    useEffect(() => {
        const mType = template.type
        setIsTS(mType.endsWith('TS'))
        switch (mType) {
            case type[6]:
                setPath('survey')
                break;
            case type[5]:
                setPath('short')
                break;
            case type[4]:
                setPath('prompt')
                break;
            case type[3]:
            case type[2]:
            case type[1]:
            case type[0]:
                setPath('trans')
                break;
            default:
        }
    }, [template]);

    useEffect(() => {
        if (path === '') return
        show(path)
    }, [path]);

    const save = async () => {
        let flag = false
        Object.values(template).forEach((item) => {
            if (item === null || item === '') flag = true
        })
        if (flag) {
            alert('템플릿의 이름 혹은 채점 방식을 선택해주세요.')
            return
        }
        const m = {...meta}
        if (m.hasOwnProperty('ai')) {
            if (m.ai.length === 0) {
                alert("사용하실 ai를 선택해주세요.")
                return
            }
            m.ai = JSON.stringify(m.ai)
        }
        const t = {...template}
        t.keywords = JSON.stringify(m.keywords)
        const response = await axios.post(`${REST_URL}activity_test_template`, t, {headers: {'prefer': 'return=representation'}})
        const templateId = response.data[0].id
        m.template_id = templateId
        await axios.post(REST_URL + 'activity_test_template_' + path, m)
        switch (path) {
            case 'prompt':
                await submitPrompt(templateId)
                break
            case 'survey':
            case 'short':
                await submitShorts(templateId)
                break
            case 'trans':
                await submitTrans(templateId)
                break
            default:
                alert('저장하실 양식을 생성해주세요!')
        }
    }

    const submitPrompt = async (templateId) => {
        const maxResponse = await axios.get(`${REST_URL}${MAX_PATH}`);
        const maxNum = maxResponse.data[0].max;
        const problemArray = []
        const selectionArray = []

        const typeIdMap = {
            "radio": 5,
            "check": 6,
            "shortTB": 7,
            "longTB": 8,
        }
        const stepMap = (key) => key.slice(-1)
        let idx = 0;
        Object.keys(problems).forEach(e => {
            problems[e].options.forEach((problem) => {
                idx += 1;
                problemArray.push({
                    id: maxNum + idx,
                    problem: problem.title,
                    test_id: 0,
                    category_id: 3,
                    difficulty_id: stepMap(e),
                    score: 0,
                    type_id: typeIdMap[problem.type],
                    template_id: templateId,
                });

                if (problem["selection"]) {
                    problem["selection"].forEach(item => {
                        selectionArray.push({
                            problem_id: maxNum + idx,
                            selection: item
                        })
                    })
                }
            })
        })
        // selectionArray.push({
        //     problem_id:step3Id,
        //     selection : step3Desc
        // })

        const lastLength = problemArray.length + 1;
        for (let i = 0; i < meta.questions; i++) {
            problemArray.push({
                id: maxNum + lastLength + i,
                problem: "",
                test_id: 0,
                category_id: 3,
                difficulty_id: 0,
                score: 0,
                type_id: 9,
                template_id: templateId,
            });
        }
        console.log(selectionArray)
        await send(problemArray, selectionArray);
    }

    const submitShorts = async (templateId) => {
        const maxResponse = await axios.get(`${REST_URL}${MAX_PATH}`);
        const maxNum = maxResponse.data[0].max;

        const problemArray = []
        const selectionArray = []

        problems.forEach((item, idx) => {
            const optionIdx = options.findIndex(option => option.key === item.type);
            problemArray.push({
                id: maxNum + idx,
                problem: item["title"],
                test_id: 0,
                category_id: 1,
                difficulty_id: 0,
                score: 0,
                type_id: optionIdx,
                template_id: templateId
            });
            if (item.type === options[0].key || item.type === options[1].key) { //OX
                item["selections"].forEach(e => {
                    selectionArray.push({
                        problem_id: maxNum + idx,
                        selection: e
                    });
                })
            }
            if (item.type === options[3].key || item.type === options[4].key) { //설문
                item["selections"].forEach(selection => {
                    selectionArray.push({
                        problem_id: maxNum + idx,
                        selection: selection
                    });
                })
            }
        })
        await send(problemArray, selectionArray);
    }

    const submitTrans = async () => {
        alert('저장되었습니다.')
        navigate(-1)
    }

    const send = async (problemArray, selectionArray) => {
        if (problemArray) await axios.post(`${REST_URL}activity_test_problem`, problemArray)
        if (selectionArray) await axios.post(`${REST_URL}activity_test_problem_selection`, selectionArray)
        alert("성공적으로 추가됐습니다.")
        navigate(-1)
    }

    return <main className={`w-full  h-screen overflow-x-scroll`}>
        <button className='m-4' onClick={save}>저장</button>
        <table className="overflow-x-auto p-4 [&_tr]: m-4">
            <thead className="bg-gray-100">
            <tr>
                <th className="px-4 py-4 border text-xl">시험 양식 번호</th>
                <th className="px-4 py-4 border text-xl">시험 양식 이름</th>
                <th className="px-4 py-4 border text-xl">채점 정보</th>
                <th className="px-4 py-4 border text-xl">시험 양식</th>
                <th className="px-4 py-4 border text-xl">평가 요소</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td className="px-4 py-4 border text-xl">
                    <input disabled className='w-100 p-2 bg-gray-100 rounded' placeholder='자동생성됩니다.'/>
                </td>
                <td className="px-4 py-4 border text-xl">
                    <input className='w-120 p-2 border-solid border-2 rounded' placeholder='시험 양식 이름'
                           value={template.name} onChange={e => setTemplate({...template, name: e.target.value})}/>
                </td>
                <td className="px-4 py-4 border text-xl">
                    <select className='w-100 p-2 border-solid rounded border-black' value={template.grading}
                            onChange={(e) => setTemplate({...template, grading: e.target.value})}>
                        <option value='' disabled>선택</option>
                        {Array.isArray(grading) && grading.map((item, index) =>
                            <option key={item + index.toString()} value={item}>{item}</option>)}
                    </select>
                </td>
                <td className="px-4 py-4 border text-xl">
                    <select className='w-100 p-2 border-solid rounded' value={template.type}
                            onChange={(e) => setTemplate({...template, type: e.target.value})}>
                        <option value='' disabled>선택</option>
                        {Array.isArray(type) && type.map((item, index) =>
                            <option key={item + index.toString()} value={item}>{item}</option>)}
                    </select>
                </td>
                <td className="px-4 py-4 border text-xl">
                    {template.keywords?.map((item, index) =>
                        <input value={item} className='p-2 border-solid border-2 rounded' key={`${index}qnopwceewijq`}
                               onChange={e => onChangeKeyword(e.target.value, index)}/>)}
                    <button className='m-4' onClick={addKeyword}>+추가</button>
                </td>
            </tr>
            </tbody>
        </table>
        <div className='m-4'>
            <Context.Provider value={{meta, setMeta, problems, setProblems, isTS, path}}>
                <Trans/>
                <Prompt/>
                <Survey/>
                <Short/>
            </Context.Provider>
        </div>
    </main>


}
